module.exports = __webpack_public_path__ + "img/EH.50d03c6f.svg";